'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
/*
 @Author : mengxiaojiang
 @CreateDate : 2016-4-1
 @Descript : 内容面板组件
 */
var ContentPanel = React.createClass({
  getInitialState: function () {
    return {
      selectedIndex: parseInt(this.props.selectedIndex, 10)
    };
  },

  //记得补充透明度
  render: function () {
    var items = this.props.items;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var style = {
      clip: 'rect(1 1 ' + (w - 1) + ' ' + (h - 1) + ')',
      border:'none',
      visibility : styleHelper.getVisible(this)?'visible':'hidden'
    };
    styleHelper.StyleUtil(this.props).background().base().bounds().default(style);
    return (
      <div
        className={"component component-" + this.props.controlTypeID}
        key={this.props.controlID}
        id={this.props.controlID}
        style={style}>
        {
          this.props.children
        }
      </div>
    )
  },

  componentDidUpdate : function(){
    this.initSelected(this.currentIndex);
    this.doBindEvent();
  },

  componentDidMount: function () {
    this.currentIndex = styleHelper.getInt(this.props, propConst.SELECTED_INDEX);
    this.initSelected(this.currentIndex);
    this.doBindEvent();
  },

  doBindEvent : function(){
    $(ReactDOM.findDOMNode(this)).off('onSwitch');
    $(ReactDOM.findDOMNode(this)).on('onSwitch', this.onSwitch);
  },

  currentIndex: undefined,

  onSwitch: function (event, controlID, currentIndex, nextIndex, complete) {
    var dom;
    var targetDom;
    var currentDom;
    var w;
    var targetOption;
    var currentOption;
    var aniType;
    var duration = 200;
    var self = this;
    var finish = function () {
      $(currentDom).css({display: 'none', visibility: 'hidden'});
      self.currentIndex = nextIndex;
      if (complete) {
        complete();
      }
    };
    if (controlID === this.props.controlID) {

      dom = ReactDOM.findDOMNode(this);
      if(_.isUndefined(nextIndex) || _.isUndefined(currentIndex)){
        if(complete){
          complete();
        }
        return;
      }
      if(nextIndex > dom.children.length - 1){
        if(complete){
          complete();
        }
        return;
      }
      targetDom = dom.children[nextIndex];
      currentDom = dom.children[currentIndex];
      if(currentIndex === nextIndex){
        finish();
        return;
      }
      w = styleHelper.getWidth(this.props);
      targetOption = {
        queue: false,
        duration: duration,
        complete: finish
      };
      currentOption = {
        queue: false,
        duration: duration
      };
      aniType = styleHelper.getPropertyValue(this.props, propConst.ANI_TYPE);
      switch (aniType) {
        case appTypes.StackPanelAniType.FADE:
          $(currentDom).css({zIndex:1}).animate({opacity: 0}, currentOption);
          $(targetDom).css({opacity: 0, display: 'block',visibility:'visible', zIndex: 2}).animate({opacity: 1}, targetOption);
          break;
        case appTypes.StackPanelAniType.PUSH:
          $(currentDom).css({zIndex:1}).animate({left: -currentDom.clientWidth}, currentOption);
          $(targetDom).css({left: w, display: 'block',zIndex:2,visibility:'visible'}).animate({left: 0}, targetOption);
          break;
        case appTypes.StackPanelAniType.SLIDE:
          $(currentDom).css({zIndex:1});
          $(targetDom).css({left: w, display: 'block',zIndex:2,visibility:'visible'}).animate({left: 0}, targetOption);
          break;
        default:

          $(targetDom).css({display: 'block', visibility: 'visible',zIndex:1});
          finish();
          break;
      }
    }
  },

  initSelected: function (selIndex) {
    var dom = ReactDOM.findDOMNode(this);
    var list = dom.children;
    var i;
    var display;
    for (i = 0; i < list.length; i++) {
      if (i === selIndex) {
        display = 'block';
      } else {
        display = 'none';
      }
      $(list[i]).css({display: display});
    }
  }
});


module.exports = ContentPanel;



// WEBPACK FOOTER //
// ./src/views/Components/ContentPanel.jsx